(function($) {
     $(() => {
        $('#toParents').click(function() {
            if ($(this).prop('checked')) {
                $.cookie('jimjamisadult', true, { path: '/' });
            } else {
                $.cookie('jimjamisadult', false, { path: '/' });
            }
            $('body').toggleClass('adult');
        });

        objectFitImages();

        if($(".iframe-modal").length){
            $(".iframe-modal").iziModal({
                history: false,
                iframe: true,
                fullscreen: true,
                headerColor: '#000000',
                openFullscreen: false,
                focusInput: false,
                appendTo: '.modals-wrapper',
                onOpening: function () {
                    $('.iframe-modal').find('iframe').attr('allowfullscreen', 'allowfullscreen');
                }
            });
        }
    


        let sticky = '';
        let easters = [];

        const $aside = $('aside');
        if ($aside.length) {
            sticky = new StickySidebar('.aside-content-wrapper', {
                topSpacing: 0,
                bottomSpacing: 0,
                containerSelector: 'aside',
                innerWrapperSelector: '.inner-wrapper-sticky',
                resizeSensor: true,
                minWidth: 991
            });

            $('#slicker').on('init', () => {
                sticky.updateSticky();
            });

            const autoplaySpeed = 0;
            let autoplayOn = false;
            let rightDir = false;

            const $slicker = $('#slicker');

            $slicker.on('init', function() {
                const $slickNext = $slicker.find('.slick-next');
                const $slickPrev = $slicker.find('.slick-prev');

                $slickNext.mouseenter(function() {
                    rightDir = false;
                    autoplayOn = true;
                });

                $slickNext.mouseleave(function() {
                    autoplayOn = false;
                });

                $slickPrev.mouseenter(function() {
                    rightDir = true;
                    autoplayOn = true;
                });

                $slickPrev.mouseleave(function() {
                    autoplayOn = false;
                });

                window.setInterval(function() {
                    if (!autoplayOn) return false;
                    if (autoplayOn) {
                        if (rightDir === false) {
                            $slicker.slick('slickNext');
                        } else {
                            $slicker.slick('slickPrev');
                        }
                    }
                }, autoplaySpeed);
            });

            $('#slicker').slick({
                dots: false,
                arrows: true,
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                vertical: true,
                verticalSwiping: true,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							vertical: false,
							verticalSwiping: false,
							slidesToShow: 12,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 992,
						settings: {
							vertical: false,
							verticalSwiping: false,
							slidesToShow: 10,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 769,
						settings: {
							vertical: false,
							verticalSwiping: false,
							slidesToShow: 7,
						}
					},
					{
						breakpoint: 576,
						settings: {
							vertical: false,
							verticalSwiping: false,
							slidesToShow: 8,
						}
					},
					{
						breakpoint: 450,
						settings: {
							vertical: false,
							verticalSwiping: false,
							slidesToShow: 6,
						}
					},
					{
						breakpoint: 380,
						settings: {
							vertical: false,
							verticalSwiping: false,
							slidesToShow: 5,
						}
					},
				]
            });

            $(window).on('resize orientationchange', () => {
                // only works on ID!
                $('#slicker').slick('refresh');
            });

            if ($('.pagination__next').length) {
                $('.infinite-scroll').infiniteScroll({
                    path: '.pagination__next',
                    append: '.infinite-scroll_row',
                    history: false,
                    status: '.page-load-status'
                });

                $('.infinite-scroll').on('append.infiniteScroll', (event, response, path, items) => {
                    sticky.updateSticky();
                });
            }

            $('#showsTab a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
                sticky.updateSticky();
            });

            if ($('.related-iframe').length) {

                $('.iframe-wrapper .related-iframe').on('click', function (e) {
                    e.preventDefault();
                    const $that = $(this);

                    if (!$(this).hasClass('already_played')) {
                        while ($that.firstChild) {
                            $that.removeChild($that.firstChild);
                        }
                        $that.append(`<iframe src="${  $(this).attr('href')  }"></iframe>`);
                        $that.addClass('already_played');
                    }
                });
            }

            if ($('.easter-egg').length) {

                for (var counter = 1; counter <= $('.easter-egg').length; counter += 1) {
                    let element = document.getElementById("easter-egg-" + counter);
                    let easter = lottie.loadAnimation({
                        container: element, // the dom element that will contain the animation
                        renderer: 'canvas',
                        loop: false,
                        autoplay: false,
                        path: `${document.getElementById("easter-egg-" + counter).getAttribute('data-url')}`
                    });
                    easters.push(easter);

                    easter.addEventListener('complete', function () {
                        element.classList.remove('show');
                    });
                }

                $(document).on('click', '.start-easter', function () {
                    $('#easter-egg-' + $(this).data('egg')).addClass('show');
                    easters[$(this).data('egg')-1].goToAndPlay(0, false);
                });
            }
        }

		 /** =============================================
		  *  FRONT PAGE DIGIT COUNTING ANIMATION
		  *  ============================================= */

		 //digit animation on front page
		 if ($(".number-anim-page").length > 0) {
			 $(window).scroll(function () {
				 var offset = 500;
				 if ($(window).width() <= 768) {
					 offset = 0;
				 }
				 var pageTop = $(window).scrollTop();
				 var pageBottom = pageTop + $(window).height();
				 var elementTop = $(".number-wrapper").offset().top + offset;

				 //if the element is in the user's viewport
				 if (pageBottom > elementTop) {
					 //$(window).off("scroll", startCounter); //to prevent the animation going off if the user continues to scroll
					 $('.number-to-anim').each(function () {
						 var $this = $(this);

						 if ($this.hasClass('duringanim')) {
							 return;
						 }

						 //if there is also text not just number
						 var number = $this.text();
						 var rest = "";
						 if ($this.text().indexOf(' ') > 0) {
							 number = $this.text().substr(0, $this.text().indexOf(' '));
							 rest = " " + $this.text().substr($this.text().indexOf(" ") + 1);
						 }

						 $this.addClass('duringanim');
						 $({Counter: 0}).animate({Counter: number}, { //set the counter first to 0 and go up until the
							 duration: 3000,                                   // initial value of the html element
							 easing: 'swing',
							 step: function () {
								 if ($this.hasClass("fraction")) { // if it's not a round number

									 //if it's the last step and the number is like 1.0, chop off the .0 from the end
									 if ((this.Counter).toFixed(2) == number && number.substr(number.length - 2) == "0") {
										 var fixed_text = number.substr(0, number.length - 2) + rest; //counter value + the non-number text
										 $this.text(fixed_text);
									 }
									 else {
										 $this.text((this.Counter).toFixed(2) + rest);  //counter value + the non-number text
									 }

								 }
								 else {
									 $this.text(Math.ceil(this.Counter) + rest); //counter value + the non-number text
								 }
							 },

							 complete: function () {
								 $this.removeClass('duringanim');
								 $this.removeClass('number-to-anim');
							 }
						 });
					 });
				 }
			 });
		 }

		 if($('.planet-wrapper').length) {
			 init();
		 }

    });
})(jQuery);
